<template>
  <div class="wrapper-common-detail">
    <div class="wrapper-content-detail">
      <div class="item-detail">
        <div class="key-detail">Nama Mesin:</div>
        <div class="value-detail f-bold">{{ nama }}</div>
      </div>
      <div class="item-detail">
        <div class="key-detail">Jenis Mesin:</div>
        <div class="value-detail" v-if="jenis === 1">Mesin Cuci</div>
        <div class="value-detail" v-else>Mesin Pengering</div>
      </div>
      <div class="item-detail">
        <div class="key-detail">Kategori Mesin:</div>
        <div class="value-detail">{{ kategori }}</div>
      </div>
    </div>
    <div class="wrapper-content-detail">
      <div class="item-detail">
        <div class="key-detail">Status Mesin:</div>
        <div class="value-detail">
          <SOInputOnOff
              v-if="!rerender && !sw"
              style="margin-top: -8px"
              :checkboxes="{
                name: 'switch-mesin',
                data: [
                  {
                    id: 'switch-mesin',
                    value: '1',
                    title: label,
                    titleBold: true,
                  },
                ]
              }"
              :checked="false"
              :disabled="!ol"
              @selected="(e) => actionOn(e)"
          />
          <SOInputOnOff
              v-if="!rerender && sw"
              style="margin-top: -8px"
              :checkboxes="{
                name: 'switch-mesin',
                data: [
                  {
                    id: 'switch-mesin',
                    value: '1',
                    title: label,
                    titleBold: true,
                  },
                ]
              }"
              :checked="true"
              :disabled="!ol"
              @selected="(e) => actionOff(e)"
          />
        </div>
      </div>
      <div class="item-detail">
        <div class="key-detail">Status Pintu:</div>
        <div class="value-detail" style="color: #6F7287" v-if="sensor === 0">Tanpa sensor pintu</div>
        <template v-else>
          <div class="value-detail" v-if="statusPintu">Terbuka</div>
          <div class="value-detail" v-else>Tertutup</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";

export default {
  name: "SOCommonDetailMesin",
  components: {SOInputOnOff},
  props: {
    nama: String,
    jenis: Number,
    kategori: String,
    sw: Boolean,
    sensor: Number,
    statusPintu: Boolean,
    ol: Boolean
  },
  data() {
    return {
      rerender: false,
      label: ""
    }
  },
  methods: {
    actionOn(e) {
      this.rerender = true
      setTimeout(() => {
        this.rerender = false
      }, 100)
      if (e) {
        this.$emit("onMesin")
      }
    },
    actionOff(e) {
      this.rerender = true
      setTimeout(() => {
        this.rerender = false
      }, 100)
      if (!e) {
        this.$emit("offMesin")
      }
    }
  },
  watch: {
    sw: {
      handler: function (v) {
        if (v) {
          this.label = `<label class='f-regular f-16 f-c-blue m-0' for='switch-mesin'>Sedang Berjalan</label>`
        } else {
          this.label = `<label class='f-regular f-16 f-c-black m-0' for='switch-mesin'>Tidak Menyala</label>`
        }
      }
    }
  },
  mounted() {
    if (this.ol) {
      if (this.sw) {
        this.label = `<label class='f-regular f-16 f-c-blue m-0' for='switch-mesin'>Sedang Berjalan</label>`
      } else {
        this.label = `<label class='f-regular f-16 f-c-black m-0' for='switch-mesin'>Tidak Menyala</label>`
      }
    } else {
      this.label = `<label class='f-regular f-16 m-0' style='color: #964040' for='switch-mesin'>Mesin Offline</label>`
    }
  }
}
</script>

<style scoped>
.wrapper-common-detail {
  margin-top: 12px;
  background-color: #FFFFFF;
  padding: 20px;
}

.wrapper-content-detail:nth-child(1) {
  padding-bottom: 20px;
  border-bottom: 1px solid #E0E0E0;
}

.wrapper-content-detail:nth-child(2) {
  padding-top: 20px;
}

.item-detail {
  display: flex;
}

.item-detail:not(:nth-child(1)) {
  margin-top: 8px;
}

.key-detail {
  color: #6F7287;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.02em;

  width: 100px;
  margin-right: 12px;
}

.value-detail {
  font-style: normal;
  font-size: 16px;
  line-height: 155%;
  letter-spacing: -0.02em;
  color: #000000;
}
</style>